import { render } from "./GridSarbatoriLegale.vue?vue&type=template&id=6830ecdd&scoped=true&ts=true"
import script from "./GridSarbatoriLegale.vue?vue&type=script&lang=ts"
export * from "./GridSarbatoriLegale.vue?vue&type=script&lang=ts"

import "./GridSarbatoriLegale.vue?vue&type=style&index=0&id=6830ecdd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6830ecdd"]])

export default __exports__